import styled from '@emotion/styled';
import { Component } from 'react';
import 'iframe-resizer/js/iframeResizer.contentWindow.min';

// Components
import WarrantyHeader from './header';
import WarrantyNav from './warranty-nav';

const WidgetContainer = styled.div`
  background-color: #ffffff;
  left: 50%;
  max-width: 1200px;
  position: relative;
  transform: translateX(-50%);
  width: 100%;
  border-radius: 3px;
  border: solid 1px #cacaca;
  box-shadow: 0 0 3px 1px #cacaca;
  background-color: #ffffff;

  a {
    transition: all 0.15s ease-in-out;
    outline: 0 !important;
    text-decoration: none;
  }
`;

/**
 * possible argument values:
 *
 *STANDARD:
 * 1. standard
 * 2. tprs
 *EXTENDED:
 * 3. system_protection
 * 4. preferred_protection
 * 5. platinum_protection
 *
 */

class Page extends Component {
  state = {
    activeWarranties: {
      standardCoverage: [],
      extendedCoverage: [],
    },
  };

  componentDidMount() {
    const { standard, tprs, systemProtection, preferredProtection, platinumProtection } = this.props;

    const standardCoverage = [];
    const extendedCoverage = [];

    if (standard) {
      standardCoverage.push('standard');
      this.setState({
        adobeData:
          '{"global":{"siteName":"widget js","widgetName":"Warranty Widget - Standard","pageName":"oc | widget | roofing | warranty","pageSection":["Widget","Roofing","Warranty"]}}',
      });
    }

    if (tprs) {
      standardCoverage.push('tprs');
      this.setState({
        adobeData:
          '{"global":{"siteName":"widget js","widgetName":"Warranty Widget - TPRS","pageName":"oc | widget | roofing | warranty","pageSection":["Widget","Roofing","Warranty"]}}',
      });
    }

    if (systemProtection) extendedCoverage.push('system-protection');
    this.setState({
      adobeData:
        '{"global":{"siteName":"widget js","widgetName":"Warranty Widget - System Protection","pageName":"oc | widget | roofing | warranty","pageSection":["Widget","Roofing","Warranty"]}}',
    });

    if (preferredProtection) {
      extendedCoverage.push('preferred-protection');
      this.setState({
        adobeData:
          '{"global":{"siteName":"widget js","widgetName":"Warranty Widget - Extended Preferred","pageName":"oc | widget | roofing | warranty","pageSection":["Widget","Roofing","Warranty"]}}',
      });
    }

    if (platinumProtection) {
      extendedCoverage.push('platinum-protection');
      this.setState({
        adobeData:
          '{"global":{"siteName":"widget js","widgetName":"Warranty Widget - Extended Platinum","pageName":"oc | widget | roofing | warranty","pageSection":["Widget","Roofing","Warranty"]}}',
      });
    }

    this.setState({
      activeWarranties: { standardCoverage, extendedCoverage },
    });
  }

  render() {
    return (
      <main>
        <div style={{ padding: '1rem' }}>
          <WidgetContainer className="main-widget-wrapper">
            <WarrantyHeader />
            <WarrantyNav activeTab={0} activeWarranties={this.state.activeWarranties} />
          </WidgetContainer>
        </div>
      </main>
    );
  }
}

export default Page;
